import React from 'react';
import CountUp from 'react-countup';
import icon1 from '../../icons/icon_token_supply.svg';
import icon2 from '../../icons/icon_token_network.svg';
import icon3 from '../../icons/icon_estimated_launch_price.svg';
import icon4 from '../../icons/icon_expected_ripple_price.svg';
import mainimg from '../../images/xrpil.png';
// import { Link } from 'react-router-dom';


const tokenomicsData = [
    { percent: '45%', title: 'Presale', count: 90000000 },
    { percent: '15%', title: 'Dex Liquidity', count: 30000000 },
    { percent: '10%', title: 'Ecosystem Fund', count: 20000000 },
    { percent: '10%', title: 'Staking Rewards', count: 30000000 },
    { percent: '8%', title: 'Team', count: 16000000 },
    { percent: '7%', title: 'DAO & Treasury', count: 14000000 },
];


const featuresData = [
    { icon: icon1, title: 'Token name', description: 'Nimanode' },
    { icon: icon2, title: 'Ticker', description: 'NMA' },
    { icon: icon3, title: 'Total Supply', description: '200,000,000 (200 Million) NMA' },
    { icon: icon4, title: 'Decimal', description: '6' },
];

const TokenomicsSection = () => {

    // const ClickHandler = () => {
    //     window.scrollTo(10, 0);
    //   }

    return (
        <section id="id_ico_token_section" className="ico_tokenomics_section section_space pb-0">
            <div className="container">
                <div className="ico_heading_block text-center" data-aos="fade-up" data-aos-duration="600">
                    <h2 className="heading_text mb-0">$NMA Tokenomics</h2>
                </div>

                <div className="row align-items-center">
                    <div className="col-lg-4 position-relative z-1">
                        <ul className="tokenomics_block unordered_list_block">
                            {tokenomicsData.map((item, index) => (
                                <li key={index} data-aos="fade-up" data-aos-duration="600" data-aos-delay={100 * (index + 1)}>
                                    <div className="percent">{item.percent}</div>
                                    <div className="info">
                                        <h4 className="heading_text">{item.title}</h4>
                                        <div className="value">[<span className="odometer" data-count={item.count}><CountUp end={item.count} enableScrollSpy scrollSpyOnce/></span><span> &nbsp; $NMA</span>]</div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-lg-4">
                        <div className="icon_coins_image">
                            <img src={mainimg} alt="ICO Coin" />
                        </div>
                    </div>

                    <div className="col-lg-4 position-relative z-1">
                        <ul className="ico_features_group unordered_list_block">
                            {featuresData.map((feature, index) => (
                                <li key={index} data-aos="fade-up" data-aos-duration="600" data-aos-delay={100 * (index + 1)}>
                                    <div className="ico_iconbox_icon_left">
                                        <div className="iconbox_icon">
                                            {/* <img src={feature.icon} alt={feature.title}/> */}
                                        </div>
                                        <div className="iconbox_info">
                                            <h3 className="iconbox_title">{feature.title}</h3>
                                            <p className="iconbox_description mb-0">{feature.description}</p>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                
            </div>
        </section>
    );
};

export default TokenomicsSection;
